module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-marker', {
    attrs: {
      "lat-lng": _vm.position,
      "title": _vm.title,
      "draggable": false
    }
  }, [_c('v-popup', {
    attrs: {
      "content": _vm.text
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa44d090"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/MarkerPopup.vue
// module id = 819
// module chunks = 0